var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseView',{attrs:{"title":"Perfil usuario"}},[_c('template',{slot:"content"},[_c('div',{attrs:{"id":"profile-settings"}},[_c('div',{staticClass:"card-nf-settings"},[_c('div',{staticClass:"card-nf-title"},[_c('h5',[_vm._v("Información básica")])]),_c('basic-information')],1)])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }